import {take, fork, put, select} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as sastActionTypes from '../sastActionTypes';
import config from '../../config';

/**
 * Calculate the distance between member's location and destination
 */
const calculateMemberLocationToDestinationDistance = function* calculateMemberLocationToDestinationDistance() {
    const {serviceManager} = yield select(state => state.application);
    const mapService = !config.IS_FALLBACK_SYSTEM
        ? serviceManager.loadService('arcGISRESTService')
        : serviceManager.loadService('googleMapsService');

    while (true) {
        const {payload} = yield take(sastActionTypes.CALCULATE_MEMBER_LOCATION_TO_DESTINATION_DISTANCE);
        const {serviceAssignmentId, destination, memberLocation} = payload;

        // calculate the distance between member's location and destination
        if (memberLocation) {
            const routeData = !config.IS_FALLBACK_SYSTEM
                ? {
                    startingPoint: {
                        longitude: destination.longitude,
                        latitude: destination.latitude,
                    },
                    destination: {
                        longitude: memberLocation.longitude,
                        latitude: memberLocation.latitude,
                    },
                } : {
                    origin: {
                        location: {
                            latLng: {
                                latitude: destination?.latitude,
                                longitude: destination?.longitude,
                            },
                        },
                    },
                    destination: {
                        location: {
                            latLng: {
                                latitude: memberLocation?.latitude,
                                longitude: memberLocation?.longitude,
                            },
                        },
                    },
                    fields: ['routes.distanceMeters'],
                };
            yield fork(
                fetchRequest,
                sastActionTypes.FETCH_MEMBER_LOCATION_TO_DESTINATION_DISTANCE_REQUEST,
                mapService.getRoute,
                {...routeData},
            );

            const routeResponseAction = yield take([
                sastActionTypes.FETCH_MEMBER_LOCATION_TO_DESTINATION_DISTANCE_REQUEST_SUCCEEDED,
                sastActionTypes.FETCH_MEMBER_LOCATION_TO_DESTINATION_DISTANCE_REQUEST_FAILED,
            ]);

            if (!routeResponseAction.error) {
                const {response} = routeResponseAction.payload;
                const routeDTO = !config.IS_FALLBACK_SYSTEM ? response.arcGISRouteDTO : response.routes[0];
                const distanceResidenceToDestination = routeDTO?.totalKilometers
                    ? routeDTO.totalKilometers
                    : routeDTO?.distanceMeters
                        ? routeDTO.distanceMeters / 1000
                        : null;

                yield put({
                    type: sastActionTypes.SET_SAST_DESTINATION_CANDIDATE_DISTANCE,
                    payload: {distanceResidenceToDestination, serviceAssignmentId},
                });
            }
        }
    }
};

export default calculateMemberLocationToDestinationDistance;
